export default {
  name: 'cdyLayout',

  watch: {
    $route: {
      handler(to) {
        // console.log(to.meta.title)
        if (to.meta.title) {
          this.title = to.meta.title;
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      title: '草都云草牧业全国大数据平台',
      time: ""
    };
  },
  created() {
    this.date()
  },
  methods: {
    date() {
      let day2 = new Date();
      day2.setTime(day2.getTime());
      let time = day2.getFullYear() + "年" + (day2.getMonth() + 1) + "月" + day2.getDate() + '日';
      this.time = time
    }
  }
};
